import { gql, useMutation } from "@apollo/client";
import { DialogContent } from "@material-ui/core";
import { Form, Formik } from "formik";
import React from "react";
import { useAppDialog } from "../../../app-dialog";
import { TicketFragment, TicketModel } from "../../../models/ticket.model";
import { BasicDialogActions } from "../../../ui/dialog";
import { LoadingButton } from "../../../ui/loading-button";
import { TicketForm } from "./ticket.form";
import { getTicketSubmission, TicketInitialValues, TicketValidationSchema } from "./ticket.validation";

const MUTATION = gql`
    mutation insert($object: ticket_insert_input!) {
        insert_ticket_one(object: $object) {
            ${TicketFragment}
        }
    }
`;

type Props = {
    event_id: number;
    onFinish: (product: TicketModel, is_new?: boolean) => void;
}

export const TicketCreate = ({
    event_id,
    onFinish,
}: Props) => {
    const [insert, status] = useMutation(MUTATION)
    const app_dialog = useAppDialog();

    const onSubmit = async (values: any) => {
        try {
            const { data } = await insert({
                variables: {
                    object: {
                        ...getTicketSubmission(values),
                        event_id,
                    }
                }
            });
            const ticket = data?.insert_ticket_one;
            if (!ticket) {
                return;
            }
            onFinish(ticket, true);
        } catch (e: any) {
            app_dialog.showError(e);
        }
    }
    return <Formik initialValues={TicketInitialValues()}
        validationSchema={TicketValidationSchema}
        onSubmit={onSubmit}>{(form_props) => <Form noValidate>
            <DialogContent>
                <TicketForm {...form_props} />
            </DialogContent>
            <BasicDialogActions>
                <LoadingButton loading={status.loading}
                    color='primary'
                    type='submit'
                    size='large'
                    variant='contained'>
                    Create
                </LoadingButton>
            </BasicDialogActions>
        </Form>}
    </Formik>
}
